import { Spin } from 'antd';
import React from 'react';

interface LoaderType {
    loaderMessage?: string;
    size?: 'default' | 'large' | 'small';
    style?: React.CSSProperties;
}

const Loader = ({ size = 'default', loaderMessage = '', style = {} }: LoaderType) => {
    return (
        <div style={style} className="min-h-full flex justify-center items-center w-full">
            <Spin size={size} tip={loaderMessage} />
        </div>
    );
};

export default Loader;
